import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import "../styles/Cart.css";
import { Alert, Modal, Spin, Switch } from "antd";
import { FaTrash, FaPlus, FaMinus, FaShoppingCart, FaLock } from "react-icons/fa";
import "../styles/Address.css";

import {
  AddAddress,
  CheckStockAtPayment,
  DeleteFromCart,
  getAddress,
  getCoupons,
  getGst,
  getProductQty,
  getShippingCost,
  Purchaseorder,
  razorpayOrder,
  SetDefaultAddress,
  stateList,
  ValidateCoupon,
  getSettings
} from "../services/Cart";
import { getWallet } from "../services/Spares";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../contextApi/CartContext";
import { withImageVersion } from "../contextApi/ImageVersionContext";
import noimage from "../assets/noimage.webp";
import { showSnackbar } from "../comopnents/snackbar";
import {
  recalculateCartItemDiscount,
  getNextQuantity,
  getPreviousQuantity,
  getQuantityStep,
} from "../utils/purchaseOptions";

// ... etc

const Checkout = () => {
  // Sample cart items data
  // First, make sure you have imported your images at the top of the file:
  const userType = localStorage.getItem("userType")?.toLowerCase();
  const { removeFromCart, deleteCartItems, setCartQty, items, replaceCartItem, fetchCart } = useContext(CartContext);
  const cartItems = useMemo(
    () => (items || []).map(recalculateCartItemDiscount),
    [items],
  );
  const [loading, setLoading] = useState(false);
  const [loadingitems, setLoadingitems] = useState(false);
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [userId, setuserId] = useState("");
  const [isapplying, setIsApplying] = useState(false);
  const [shippingCost, setShippingCost] = useState(0);
  const [deliveryOption, setDeliveryOption] = useState("");
  const [selectedTransport, setSelectedTransport] = useState("");
  const [address, setAddress] = useState([]);
  const [addressid, setAddressid] = useState();
  const [billingId, setBillingId] = useState();
  const [statecode, setStatecode] = useState("");
  const [billStatecode, setBillStatecode] = useState("");
  const [d_pin, setd_pin] = useState(0);
  const [walletAmount, setWalletAmount] = useState("0.00");
  const [coupon, setCoupon] = useState("");
  const [couponid, setCouponid] = useState("");
  const [couponAmount, setCouponAmount] = useState(0);
  const [coupons, setCoupons] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [addingAddress, setAddingAddress] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [states, setStates] = useState([]);
  const [loadingStates, setLoadingStates] = useState(false);
  const [gstLoading, setGstLoading] = useState(false);
  const gstFetchIdRef = useRef(0);
  const lastFetchedGstRef = useRef("");
  const [showPaymentMethodModal, setShowPaymentMethodModal] = useState(false);
  const [showTransportModal, setShowTransportModal] = useState(false);
  const [acceptTransportTerms, setAcceptTransportTerms] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("razorpay"); // "razorpay" | "bank"
  const [utrNumber, setUtrNumber] = useState("");
  const [utrError, setUtrError] = useState("");
  const [submittingBankTransfer, setSubmittingBankTransfer] = useState(false);
  const [newAddress, setNewAddress] = useState({
    name: "",
    firmname: "",
    phone: "",
    altphone: "",
    email: "",
    flathouse: "",
    area: "",
    landmark: "",
    city: "",
    state: "",
    statecode: "",
    pincode: "",
    country: "India",
    type: "",
    gstno: "",
    useSameAddressForBilling: true,
  });
  const navigate = useNavigate();
  const [useWallet, setUseWallet] = useState(false); // Track toggle
  const [shippingSetting, setShippingSetting] = useState(0);
  const [walletSetting, setWalletSetting] = useState(0);
  const BANK_DETAILS = {
    accountName: "Pixel Tools Company Private Limited",
    accountNumber: "437051000014",
    ifsc: "ICIC0004370",
    bankName: "ICICI BANK",
    branch: "HITECH CITY",
  };
  const [totals, setTotals] = useState({
    totalMRP: 0,
    totalDiscountAmount: 0,
    totalCost: 0,
    totalWeight: 0,
    totalGst: 0,
    totalGross: 0,
    totalSpecialDisc: 0,
    totalDlrDisc: 0,
  });
  const showModal = () => {
    setIsModalOpen(true);
  };
  const onChange = checked => {

    if (totals.totalGross >= walletSetting) {
      setUseWallet(checked);
    } else {
      setUseWallet(false);
    }
  };
  const handleOk = () => {
    // Logic for when the OK button is clicked (e.g., form submission)
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    // Logic for when the Cancel button is clicked, or the mask is clicked
    setIsModalOpen(false);
  };
  useEffect(() => {
    const id = localStorage.getItem("userId");
    setuserId(id);
  }, []);

  useEffect(() => {
    fetchCart();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getWallet();
        console.log("wallet fetched:", response);
        setWalletAmount(response.data[0]?.amount >= 200 ? 200 : response.data[0]?.amount);
      } catch (err) {
        console.log(err);
      } finally {
        console.log("wallet");
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchCoupons = async () => {
      setLoading(true);
      try {
        const response = await getCoupons();
        console.log("COUPONS", response.Data);
        setCoupons(response.Data || []);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchCoupons();
  }, []);
  useEffect(() => {
    const fetchSettings = async () => {
      setLoading(true);

      try {
        const response = await getSettings();

        console.log("SETTINGS:", response);

        const settings = response?.data || [];

        const shippingObj = settings.find(
          (item) => item.name === "Delivary"
        );
        const walletObj = settings.find(
          (item) => item.name === "Wallet"
        );

        setShippingSetting(Number(shippingObj?.value) || 0);
        setWalletSetting(Number(walletObj?.value) || 0);

        console.log("SHIPPING SETTING:", Number(shippingObj?.value) || 0);
      } catch (err) {
        console.error("Error fetching settings:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const getUserData = () => ({
    name:
      localStorage.getItem("firstName") ||
      localStorage.getItem("first_name") ||
      localStorage.getItem("name") ||
      "",
    email: localStorage.getItem("email") || localStorage.getItem("userName") || "",
    phone: localStorage.getItem("mobile") || localStorage.getItem("Mobile") || "",
    userId: localStorage.getItem("userId") || "",
    gst: localStorage.getItem("GST") || "",
  });

    const n = (v) => Number(String(v).replace(/[^\d.]/g, "")) || 0;


   const payableShippingCost = useMemo(() => {
    if (deliveryOption !== "door" || n(totals?.totalGross) >= shippingSetting) {
      return 0;
    }

    return n(shippingCost);
  }, [deliveryOption, shippingCost, totals?.totalGross, shippingSetting]);


    const totalPayable = useMemo(() => {
    const gross = n(totals?.totalGross);
    const wallet = useWallet ? n(walletAmount) : 0.00;
    const coupon = n(couponAmount) || 0;
    const shipping = payableShippingCost;

    const base = gross - wallet - coupon;
    const base1 = gross - wallet - coupon + shipping;
    return Number(gross >= shippingSetting ? base : base1).toFixed(2);
  }, [
    totals?.totalGross,
    totals?.totalCost,
    walletAmount,
    couponAmount,
    payableShippingCost,
    useWallet,
    shippingSetting,
  ]);

  const validateAddressForm = (addressData) => {
    const errors = {};

    if (!addressData.name?.trim()) {
      errors.name = "Full name is required";
    } else if (addressData.name.trim().length < 3) {
      errors.name = "Name must be at least 3 characters";
    }

    if (!addressData.phone?.trim()) {
      errors.phone = "Mobile number is required";
    } else if (!/^\d{10}$/.test(addressData.phone)) {
      errors.phone = "Please enter a valid 10-digit mobile number";
    }

    if (
      addressData.altphone?.trim() &&
      !/^\d{10}$/.test(addressData.altphone)
    ) {
      errors.altphone = "Alternate number must be 10 digits";
    }

    if (
      addressData.email?.trim() &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(addressData.email)
    ) {
      errors.email = "Please enter a valid email address";
    }

    if (!addressData.flathouse?.trim()) {
      errors.flathouse = "Flat/House number is required";
    }

    if (!addressData.area?.trim()) {
      errors.area = "Area/Street is required";
    }

    if (!addressData.city?.trim()) {
      errors.city = "City is required";
    }

    if (!addressData.state?.trim()) {
      errors.state = "State is required";
    }

    if (!addressData.pincode?.trim()) {
      errors.pincode = "Pincode is required";
    } else if (!/^\d{6}$/.test(addressData.pincode)) {
      errors.pincode = "Please enter a valid 6-digit pincode";
    }

    if (!addressData.type) {
      errors.type = "Address type is required";
    } else if (!["SHIP", "BILL"].includes(addressData.type)) {
      errors.type = "Address type must be either Shipping or Billing";
    }

    if (addressData.gstno?.trim()) {
      const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (!gstRegex.test(addressData.gstno)) {
        errors.gstno = "Please enter a valid GST number";
      }
    }

    return errors;
  };

  const handleOpenAddAddressModal = () => {
    const userData = getUserData();
    setNewAddress({
      name: userData.name,
      firmname: userData.gst ? userData.gst : "",
      phone: userData.phone,
      altphone: "",
      email: userData.email,
      flathouse: "",
      area: "",
      landmark: "",
      city: "",
      state: "",
      statecode: "",
      pincode: "",
      country: "India",
      type: "",
      gstno: userData.gst,
      useSameAddressForBilling: true,
    });
    setFormErrors({});
    setShowAddressModal(true);
  };

  const handleCloseAddressModal = () => {
    setShowAddressModal(false);
    setFormErrors({});
    setNewAddress({
      name: "",
      firmname: "",
      phone: "",
      altphone: "",
      email: "",
      flathouse: "",
      area: "",
      landmark: "",
      city: "",
      state: "",
      statecode: "",
      pincode: "",
      country: "India",
      type: "",
      gstno: "",
      useSameAddressForBilling: true,
    });
  };

  const handleNewAddressChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewAddress((prev) => ({
      ...prev,
      [name]: name === "gstno" ? value.toUpperCase() : type === "checkbox" ? checked : value,
    }));

    if (formErrors[name]) {
      setFormErrors((prev) => {
        const next = { ...prev };
        delete next[name];
        return next;
      });
    }

    const upper = name === "gstno" ? value.toUpperCase().trim() : "";
    if (name === "gstno" && gstRegex.test(upper)) {
      fetchGstDetails(upper);
    }
  };

  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  const fetchGstDetails = async (gstValue) => {
    const gst = gstValue?.trim();
    if (!gst) return;
    if (!gstRegex.test(gst)) {
      setFormErrors((prev) => ({ ...prev, gstno: "Please enter a valid GST number" }));
      return;
    }
    if (lastFetchedGstRef.current === gst) return;

    const requestId = ++gstFetchIdRef.current;
    lastFetchedGstRef.current = gst;
    setGstLoading(true);
    try {
      const res = await getGst(gst);
      if (requestId !== gstFetchIdRef.current) return;

      const gstData = res?.data || res;
      const addressDetails = gstData.address_details || {};

      const gstStateCode = gstData.state_code || gstData.stateCode || "";
      const matchedState = gstStateCode
        ? states.find((s) => String(s.code) === String(gstStateCode))
        : null;

      setNewAddress((prev) => ({
        ...prev,
        gstno: gst.toUpperCase(),
        name: prev.name,
        firmname: gstData.legal_name || gstData.trade_name || "",
        flathouse: addressDetails.building_number || prev.flathouse,
        area: addressDetails.street || prev.area,
        landmark: addressDetails.landmark || prev.landmark,
        city: gstData.city || addressDetails.locality || prev.city,
        state: matchedState
          ? (matchedState.statename || matchedState.state || matchedState.name)
          : (gstData.state || prev.state),
        statecode: matchedState ? String(matchedState.code || matchedState.id || "") : prev.statecode,
        pincode: gstData.pincode || addressDetails.pincode || prev.pincode,
      }));
    } catch (err) {
      if (requestId !== gstFetchIdRef.current) return;
      console.error("GST API error:", err);
      showSnackbar("Failed to fetch GST details", "error");
    } finally {
      if (requestId === gstFetchIdRef.current) {
        setGstLoading(false);
      }
    }
  };

  const handleGstBlur = () => {
    fetchGstDetails(newAddress.gstno);
  };

  const handleAddAddress = async () => {
    const userData = getUserData();
    const errors = validateAddressForm(newAddress);

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      const errorMessages = Object.values(errors).join("\n• ");
      alert(`Please fix the following errors:\n• ${errorMessages}`);
      return;
    }

    setAddingAddress(true);
    try {
      const response = await AddAddress({
        addressType: newAddress.type,
        altphone: newAddress.altphone,
        area: newAddress.area,
        city: newAddress.city,
        country: newAddress.country,
        customerid: userData.userId,
        email: newAddress.email,
        flathouse: newAddress.flathouse,
        gstno: newAddress.gstno,
        landmark: newAddress.landmark,
        name: newAddress.name,
        firmname: newAddress.firmname,
        phone: newAddress.phone,
        pincode: newAddress.pincode,
        state: newAddress.state,
        statecode: newAddress.statecode,
        stateid: Number(newAddress.statecode || 0),
        type: newAddress.type,
        useSameAddressForBilling: newAddress.useSameAddressForBilling,
      });

      if (
        response &&
        (response.status === 200 || response.status === 201 || response.success === true)
      ) {
        const refreshed = await getAddress();
        const updatedAddresses = refreshed?.Data || [];
        const targetTypes = newAddress.useSameAddressForBilling
          ? ["SHIP", "BILL"]
          : [newAddress.type];

        const defaultIdsByType = {};

        targetTypes.forEach((type) => {
          const sameTypeMatches = updatedAddresses.filter((item) => item.type === type);
          const exactMatch = sameTypeMatches
            .filter((item) => {
              const matchesAddress =
                String(item.phone || "") === String(newAddress.phone || "") &&
                String(item.flathouse || "") === String(newAddress.flathouse || "") &&
                String(item.area || "") === String(newAddress.area || "") &&
                String(item.city || "") === String(newAddress.city || "") &&
                String(item.pincode || "") === String(newAddress.pincode || "");

              return matchesAddress;
            })
            .sort((a, b) => Number(b.id) - Number(a.id));

          const primaryDefaultId = exactMatch[0]?.id || sameTypeMatches.sort((a, b) => Number(b.id) - Number(a.id))[0]?.id;
          if (primaryDefaultId) {
            defaultIdsByType[type] = primaryDefaultId;
          }
        });

        if (Object.keys(defaultIdsByType).length > 0) {
          await Promise.all(
            Object.entries(defaultIdsByType).map(([type, id]) =>
              SetDefaultAddress({
                customerid: userData.userId,
                type,
                id,
              }),
            ),
          );

          const defaultedAddresses = updatedAddresses.map((item) => {
            const isTypeDefault = item.type in defaultIdsByType && defaultIdsByType[item.type] === item.id;
            return {
              ...item,
              default: isTypeDefault ? "1" : item.type in defaultIdsByType ? "0" : item.default,
            };
          });

          setAddress(defaultedAddresses);

          const shippingDefault = defaultedAddresses.find((item) => item.type === "SHIP" && item.default === "1");
          const billingDefault = defaultedAddresses.find((item) => item.type === "BILL" && item.default === "1");

          if (shippingDefault) {
            setAddressid(shippingDefault.id);
            setStatecode(shippingDefault.statecode || shippingDefault.stateCode || "");
            setd_pin(shippingDefault.pincode);
          }

          if (billingDefault) {
            setBillingId(billingDefault.id);
            setBillStatecode(billingDefault.statecode || billingDefault.stateCode || "");
          }
        } else {
          setAddress(updatedAddresses);
        }

        setShowAddressModal(false);
        setFormErrors({});
        setNewAddress({
          name: "",
          firmname: "",
          phone: "",
          altphone: "",
          email: "",
          flathouse: "",
          area: "",
          landmark: "",
          city: "",
          state: "",
          statecode: "",
          pincode: "",
          country: "India",
          type: "",
          gstno: "",
          useSameAddressForBilling: true,
        });
        showSnackbar("Address added successfully!");
      } else {
        showSnackbar("Failed to add address", "error");
      }
    } catch (err) {
      console.error("Add address failed:", err);
      showSnackbar("Failed to add address", "error");
    } finally {
      setAddingAddress(false);
    }
  };

  useEffect(() => {
    const fetchStates = async () => {
      setLoadingStates(true);
      try {
        const response = await stateList();
        const raw = response?.data ?? response ?? [];
        const stateData = Array.isArray(raw?.List)
          ? raw.List
          : Array.isArray(raw)
            ? raw
            : Array.isArray(raw?.data)
              ? raw.data
              : [];
        setStates(stateData);
      } catch (error) {
        console.error("Failed to load states:", error);
      } finally {
        setLoadingStates(false);
      }
    };

    fetchStates();
  }, []);

  // const handleApplyCoupon = async (() => {
  //   setIsApplying(true);
  //   console.log(totals.totalCost, coupon);
  //   const orderValue =
  //     totalPayable

  //   try {
  //     // Simulate coupon validation API
  //     const isValid = await ValidateCoupon({
  //       id: couponid,
  //       customerid: userId,
  //       ordervalue: orderValue,
  //     }); // replace with real API
  //     if (isValid.data > 0) {
  //       console.log("couponAmount", isValid);
  //       setCouponAmount(isValid.data);
  //       // totals.totalCost = totals.totalCost - isValid.data
  //     } else {
  //       setCouponAmount(0);
  //       alert(isValid.error);
  //     }
  //   } catch (error) {
  //     alert(error);
  //   } finally {
  //     setIsApplying(false);
  //   }
  // },[totals.totalGross, couponid, userId]);

  const handleApplyCoupon = useCallback(async () => {
    let cid = couponid;

    if (!cid) {
      const found = (coupons || []).find(
        (c) =>
          String(c?.couponid).toLowerCase() ===
          String(coupon || "").trim().toLowerCase(),
      );
      cid = found?.cid;
    }

    if (!cid) {
      showSnackbar("warning", "Please select a valid coupon");
      return;
    }

    setIsApplying(true);
    console.log(totals.totalCost, coupon);
    const orderValue = totalPayable;

    try {
      const isValid = await ValidateCoupon({
        id: cid,
        customerid : userId,
        ordervalue : paymentMethod === "bank" ? totalPayable - 0.02*totalPayable : totalPayable,
      });

      if (isValid?.data > 0) {
        console.log("couponAmount", isValid);
        setCouponAmount(isValid.data);
        // showSnackbar("success", "Coupon applied successfully!");
      } else {
        setCouponAmount(0);
        showSnackbar("warning", "Coupon not Applicable");
      }
    } catch (error) {
      showSnackbar("error", error?.message || "Failed to apply coupon");
    } finally {
      setIsApplying(false);
    }
  }, [couponid,  totalPayable ,deliveryOption, payableShippingCost]);

  const handlePress = async (userId, productid, newQty, stock, minqty, fnc) => {
    console.log(userId, productid, newQty, stock, fnc);
    const currentItem = cartItems.find(
      (item) => String(item.dtl?.[0]?.productid) === String(productid),
    );
    const productData = currentItem?.dtl?.[0] || { minorderqty: minqty };
    const nextQty =
      fnc === "add"
        ? getNextQuantity(currentItem?.qty, productData)
        : getPreviousQuantity(currentItem?.qty, productData);

    if (nextQty < getQuantityStep(productData)) return;
    // Stop if exceeding stock
    if (nextQty > stock && fnc === "add") {
      alert("Limited Stock Available");
      return;
    }
    try {
      const response = await getProductQty({
        user_id: userId,
        productid,
        qty: nextQty,
      });
      const itemData = response.data[0] || {
        ...currentItem,
        qty: nextQty,
      };
      if (itemData?.dtl?.[0] && currentItem?.dtl?.[0]) {
        itemData.dtl[0].Qtydiscounts ||= currentItem.dtl[0].Qtydiscounts || [];
        itemData.dtl[0].discount_items ||= currentItem.dtl[0].discount_items || [];
        itemData.dtl[0].discount ||= currentItem.dtl[0].discount;
        itemData.dtl[0].mrp ||= currentItem.dtl[0].mrp;
        itemData.qty = nextQty;
      }
      const updatedItem = recalculateCartItemDiscount(itemData);
      replaceCartItem(productid, updatedItem);
      setCartQty(productid, nextQty);

    } catch (error) {
      console.error("API Error:", error?.message || error);
    }
  };

  const handleDelete = async (userId, productid) => {
    try {
      console.log(typeof userId);
      console.log(productid);
      const response = await DeleteFromCart({
        customerid: userId,
        productid: productid,
      });
      console.log("API Response:", response);
      // Replace the matching item with the full item returned by the API
      if (response.status === 200) {
        removeFromCart(productid);
      }
    } catch (error) {
      console.error("API Error:", error?.message || error);
      // Optionally show a toast or revert UI
    }
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       const [getAddressRes] = await Promise.allSettled([getAddress()]);

  //       if (getAddressRes.status === "fulfilled") {
  //         const addresses = getAddressRes.value?.Data || [];
  //         setAddress(addresses);

  //         const defaultBilling = addresses.find(
  //           (item) => item.type === "BILL" && item.default === "1",
  //         );
  //         if (defaultBilling) {
  //           console.log(defaultBilling);
  //           setBillingId(defaultBilling.id);
  //           setBillStatecode(defaultBilling.statecode);
  //         }

  //         const defaultShipping = addresses.find(
  //           (item) => item.type === "SHIP" && item.default === "1",
  //         );
  //         if (defaultShipping) {
  //           console.log(defaultShipping);
  //           setd_pin(defaultShipping.pincode);
  //           setAddressid(defaultShipping.id);
  //           setStatecode(defaultShipping.statecode);
  //           fetchShipping(defaultShipping.pincode);
  //         }
  //       } else {
  //         console.warn("Address fetch failed:", getAddressRes.reason);
  //       }
  //     } catch (err) {
  //       //   setError(err);
  //       console.error("Unexpected error:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [totals.totalWeight]);

  // const fetchShipping = async (pin) => {
  //   try {
  //     setLoading(true);

  //     const res = await getShippingCost({
  //       cgm: totals.totalWeight,
  //       d_pin: pin, // use passed pin
  //     });

  //     setShippingCost(res?.data?.[0]?.total_amount ?? 0);

  //   } catch (err) {
  //     console.error("Shipping cost fetch failed:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      setLoading(true);
      try {
        const [getAddressRes] = await Promise.allSettled([getAddress()]);
        if (getAddressRes.status === "fulfilled") {
          const addresses = getAddressRes.value?.Data || [];
          setAddress(addresses);
          const defaultBilling = addresses.find(
            (item) => item.type === "BILL" && item.default === "1",
          );
          if (defaultBilling) {
            console.log(defaultBilling);
            setBillingId(defaultBilling.id);
            setBillStatecode(defaultBilling.statecode);
          }
          const defaultShipping = addresses.find(
            (item) => item.type === "SHIP" && item.default === "1",
          );
          if (defaultShipping && !cancelled) {
            setd_pin(defaultShipping.pincode);
            setAddressid(defaultShipping.id);
            setStatecode(defaultShipping.statecode);
            await fetchShipping(defaultShipping.pincode, cancelled);
          }
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchData();
    return () => { cancelled = true; };
  }, [totals.totalWeight]);

  const fetchShipping = useCallback(async (pin, cancelledRef) => {
  try {
    setLoading(true);

    const res = await getShippingCost({ cgm: totals.totalWeight, d_pin: pin });

    if (!cancelledRef) {
      setShippingCost(res?.data?.[0]?.total_amount ?? 0);
      console.log("Shipping cost fetched:", res?.data?.[0]?.total_amount);
    }
  } catch (err) {
    console.error("Shipping cost fetch failed:", err);
  } finally {
    if (!cancelledRef) setLoading(false);
  }
}, [totals.totalWeight, addressid]);

  const loadRazorpay = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async (amount, id) => {
    console.log("Amount payable", amount, "id", id);
    const res = await loadRazorpay();
    if (!res) {
      alert("Razorpay SDK failed to load");
      return;
    }
    var options = {
      description: "Order payment",
      image: "https://pixeltools.in/test/social/pixellogo.png",
      currency: "INR",
      // key: "rzp_test_STM89cn1fpd5SQ",
      key: "rzp_live_TBmkonvMxebjpU",


      amount: amount,
      name: "Pixel Tools Private Limited",
      order_id: id, // get this from backend via Razorpay Orders API
      handler: function (response) {
        console.log("Payment Success", response);
        getPurchaseOrder(
          response.razorpay_signature,
          response.razorpay_payment_id,
          response.razorpay_order_id,
          amount / 100,
        );
        console.log("Payment ID:", response.razorpay_payment_id);
      },
      modal: {
        ondismiss: function () {
          console.log("Payment popup closed");
        },
      },
      prefill: {
        email: localStorage.getItem("userName"),
        contact: localStorage.getItem("Mobile"),
        name: localStorage.getItem("name"),
      },
      theme: { color: "#005487" },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
    // You can now place the order, clear cart, navigate, etc.
    // getPurchaseOrder(
    //     data.razorpay_signature,
    //     data.razorpay_payment_id,
    //     data.razorpay_order_id,
    //     amount / 100,

    // )
    //         .catch(error => {
    //             console.log(`Error: ${error.code} | ${error.description}`);
    //         });
  };

  const validateAndCheckStock = async () => {
    if (!deliveryOption) {
      showSnackbar("warning", "Please select a delivery option.");
      return false;
    }

    if (deliveryOption === "transport" && !selectedTransport.trim()) {
      showSnackbar("warning", "Please enter the transport office.");
      return false;
    }

    const defaultShipping = address.find(
      (item) => item.type === "SHIP" && item.default === "1",
    );
    const defaultBilling = address.find(
      (item) => item.type === "BILL" && item.default === "1",
    );
    if (!defaultShipping || !defaultBilling) {
      showSnackbar("warning", "Add Billing And Shipping Address");
      return false;
    }
    if (totals.totalWeight > 20000) {
      showSnackbar("warning", "Total Weight is Above 20kg");
    }

    for (const item of cartItems) {
      const productid = item.dtl?.[0]?.productid;
      try {
        const mainResponse = await CheckStockAtPayment({
          billingaddressid: billingId,
          billingstatecode: billStatecode,
          cgst: billStatecode == "36" ? String((item.gstp / 2).toFixed(2)) : "0.00",
          cgstamount: billStatecode == "36" ? String((item.gsta / 2).toFixed(2)) : "0.00",
          disamount: String(item.disa),
          dispatchqty: "0",
          dispercent: String(item.disp),
          exdisamount: 0,
          gstamount: String(item.gsta),
          gstpercent: String(item.gstp),
          igst: billStatecode == "36" ? "0" : String((item.gstp).toFixed(2)),
          igstamount: billStatecode == "36" ? "0" : String((item.gsta).toFixed(2)),
          mrp: String(item.mrp),
          mrptotal: item.rate,
          orderqty: String(item.qty),
          packingqty: "0",
          productid: String(productid),
          rate: item.rate,
          sdisamount: item.splamount || 0,
          sdispercent: item.spldis || 0,
          sgst: billStatecode == "36" ? String((item.gstp / 2).toFixed(2)) : "0",
          sgstamount: billStatecode == "36" ? String((item.gsta / 2).toFixed(2)) : "0",
          shippingaddressid: addressid,
          shippingstatecode: statecode,
          totalamount: item.gross || 0,
        });

        if (mainResponse.data.status !== "success") {
          alert("Products out of stock");
          return false;
        }
      } catch (err) {
        console.error("API checkstock Error:", err);
        return false;
      }
    }

    return true;
  };

  const handleBankTransferSubmit = async () => {
    if (!utrNumber.trim()) {
      setUtrError("Please enter the UTR / reference number");
      return;
    }
    if (!/^[A-Za-z0-9]{6,25}$/.test(utrNumber.trim())) {
      setUtrError("Please enter a valid UTR number");
      return;
    }
    setUtrError("");

    setSubmittingBankTransfer(true);
    try {
      const ok = await validateAndCheckStock();
      if (!ok) return;

      setShowPaymentMethodModal(false);

      await getPurchaseOrder(
        'sig78945876',        // sign - N/A for bank transfer
        utrNumber.trim(),       // tnxNum -> used as tnxnumber
        "Bank Transfer",        // tnxorder -> used as tnxorder
        (Number(totalPayable) * 0.98).toFixed(2),
      );
    } finally {
      setSubmittingBankTransfer(false);
    }
  };

  // Replaces the old checkStockBeforePayment for the Razorpay path
  const checkStockBeforePayment = async (finalAmount, currency, capture) => {
    const ok = await validateAndCheckStock();
    if (!ok) return null;
    getRazorpayId(finalAmount, currency, capture);
  };

  const getRazorpayId = async (finalAmount, currency, capture) => {
    console.log(finalAmount)
    try {
      // Simulate coupon validation API
      const response = await razorpayOrder({
        amount: Number(finalAmount),
        currency: currency,
        payment_capture: capture,
      }); // replace with real API
      console.log("RAZRPAYID", response);
      if (response.status === "created") {
        handlePayment(response.amount_due, response.id);
      } else {
        Alert.alert("err");
      }
    } catch (error) {
      alert("Failed ", error);
    } finally {
      setIsApplying(false);
    }
  };
  const getPurchaseOrder = async (sign, tnxNum, tnxorder, amount) => {

    try {
      let dtlArray = [];
      cartItems.forEach((item) => {
        dtlArray.push({
          billing: billingId,
          billstatecode: String(billStatecode),
          cgst: billStatecode == "36" ? String((item.gstp / 2).toFixed(2)) : "0.00",
          cgstamount:
            billStatecode == "36" ? String((item.gsta / 2).toFixed(2)) : "0.00",
          disamount: item.disamount || item.disa,
          dispatchqty: "0",
          dispercent: item.dis || item.disp,
          gstamount: String(item.gsta),
          gstpercent: String(item.gstp),
          igst: billStatecode == "36" ? "0.00" : String((item.gstp).toFixed(2)),
          igstamount:
            billStatecode == "36" ? "0.00" : String((item.gsta).toFixed(2)),
          mrp: String(item.dtl[0]?.mrp),
          mrptotal: String(item?.mrp),
          orderqty: item.qty,
          packingqty: "0",
          productid: String(item.dtl[0]?.productid),
          rate: item.gross,
          sdisamount: item.splamount,
          sdispercent: item.spldis,
          sgst: billStatecode == "36" ? String((item.gstp / 2).toFixed(2)) : "0.00",
          sgstamount:
            billStatecode == "36" ? String((item.gsta / 2).toFixed(2)) : "0.00",
          shiping: addressid,
          shipstatecode: statecode,
          totalamount: item.gross,
          type: "r",
        });
        if (
          item.dtl[0]?.free_items &&
          item.dtl[0]?.free_items.length > 0 &&
          Number(item?.qty) >= Number(item?.dtl?.[0]?.free_items?.[0]?.minqty)
        ) {
          item.dtl[0]?.free_items.forEach((freeItem) => {
            dtlArray.push({
              billing: billingId,
              billstatecode: billStatecode,
              cgst: billStatecode == "36" ? String(item.gstp / 2) : "0",
              cgstamount: billStatecode == "36" ? String(item.gsta / 2) : "0",
              disamount: freeItem.disa,
              dispatchqty: freeItem.qty,
              dispercent: "0",
              gstamount: "0",
              gstpercent: "0",
              igst: billStatecode == "36" ? "0" : String(item.gstp),
              igstamount: billStatecode == "36" ? "0" : String(item.gsta),
              mrp: "0",
              mrptotal: "0",
              orderqty: freeItem.qty,
              packingqty: freeItem.qty,
              productid: freeItem.feeproductid,
              rate: "0",
              sdisamount: "0",
              sdispercent: "0",
              sgst: billStatecode == "36" ? String(item.gstp / 2) : "0",
              sgstamount: billStatecode == "36" ? String(item.gsta / 2) : "0",
              shiping: addressid,
              shipstatecode: statecode,
              totalamount: "0",
              type: "f",
            });
          });
        }
      });
      console.log(dtlArray);
      setLoadingPayment(true);
      setIsPaymentModalOpen(true);
      // Simulate coupon validation API
      const response = await Purchaseorder({
        dtl: dtlArray,
        hdr: {
          bank_rrn: utrNumber || "Not Available",
          billing: billingId,
          billstatecode: billStatecode,
          cgm: totals.totalWeight,
          couponamount:  couponAmount,
          couponcode: coupon,
          delivarycharges: payableShippingCost,
          deliveryoption: deliveryOption,
          transport: deliveryOption === "transport" ? selectedTransport : "",
          discount: totals.totalDiscountAmount + couponAmount,
          dispatch: "0",
          dispatchby: "0",
          gstamount: (totals.totalGst).toFixed(2),
          mrptotal: totals.totalMRP,
          netamount:  Number(totalPayable).toFixed(2),
          orderstatus: "Success",
          packing: "0",
          packingby: "0",
          po: "1",
          razorpay_signature: sign,
          savedamount: savedAmount,
          shiping: addressid,
          shipstatecode: statecode,
          tnxnumber: tnxNum,
          tnxorder: tnxorder,
          total: amount,
          userid: userId,
          wallet: useWallet ? Number(walletAmount) : 0.00,
        },
      });
      console.log("po response", response);
      if (response.data.Data === 'Your Order Processed Successfully') {
        setLoadingPayment(false);
        // Alert.alert("Successful", `orderId: ${"tnxorder"}`)
        deleteCartItems();
        navigate("/PurchaseResult");
      } else {
        // Alert.alert('err');
        console.log("po err", "error");
        setLoadingPayment(false);
        setIsPaymentModalOpen(false);
      }
    } catch (error) {
      setLoadingPayment(false);
      console.log("po err", error);
      // Alert.alert('Failed ', error);
    } finally {
      setIsApplying(false);
      setIsPaymentModalOpen(false);
    }
  };
  // Update quantity

  useEffect(() => {
    if (!Array.isArray(cartItems) || cartItems.length === 0) {
      setTotals({
        totalMRP: 0,
        totalDiscountAmount: 0,
        totalCost: 0,
        totalWeight: 0,
        totalGst: 0,
        totalGross: 0,
        totalSpecialDisc: 0,
        totalDlrDisc: 0,
      });
      return;
    }

    const calculated = cartItems.reduce(
      (acc, item) => {
        const mrp = item.dtl[0]?.netrate ? Number(item.dtl[0]?.netrate * item.qty) : Number(item?.mrp || 0);
        const discount = item?.disp || 0;
        const spcl = item?.splamount || 0;
        const dlr = item?.dealerdisamt || 0;
        const gst = item?.gsta || 0;
        const qty = item?.qty || 1;
        const weight = item?.dtl?.[0]?.netw || 0;
        const netrate = Number(item.dtl?.[0]?.netrate * item.qty || 0);
        const gross = netrate > 0 ? netrate : Number(item?.gross || 0);
        // ---------- per item calculations ----------
        const totalMRP = mrp;
        const discountAmt = ((mrp * discount) / 100);
        const costAfterDisc = totalMRP - discountAmt;
        const totalWeight = weight * qty;

        // ---------- accumulate ----------
        acc.totalMRP += totalMRP;
        acc.totalDiscountAmount += discountAmt;
        acc.totalCost += costAfterDisc;
        acc.totalGst += gst;
        acc.totalWeight += totalWeight;
        acc.totalSpecialDisc += spcl;
        acc.totalDlrDisc += dlr;
        acc.totalGross += gross;

        return acc;
      },
      {
        totalMRP: 0,
        totalDiscountAmount: 0,
        totalCost: 0,
        totalWeight: 0,
        totalGst: 0,
        totalSpecialDisc: 0,
        totalDlrDisc: 0,
        totalGross: 0,
      },
    );

    setTotals(calculated);
  }, [cartItems, shippingCost]);

  const isHeavyWeight = Number(totals.totalWeight) > 30000;

  useEffect(() => {
    if (isHeavyWeight && deliveryOption !== "transport") {
      setDeliveryOption("transport");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHeavyWeight]);

  useEffect(() => {
    if (!couponid || cartItems.length === 0) return;
    handleApplyCoupon();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totals.totalGross, deliveryOption, payableShippingCost, paymentMethod]);

  const savedAmount = 0;
  // const savedAmount = useWallet ? items[0]?.gross - Number(walletAmount) : items[0]?.gross * 1.18 > 1000
  //   ? Math.ceil(totals.totalDiscountAmount + couponDiscount + shippingCost + totals.totalDlrDisc)
  //   : Math.ceil(totals.totalDiscountAmount + couponDiscount + totals.totalSpecialDisc + totals.totalDlrDisc)
  // Calculate subtotal
  const calculateSubtotal = () => {
    return cartItems.reduce((total, item) => {
      return total + Number(item.gross || 0);
    }, 0);
  };

  // Calculate shipping (free above ₹500)
  const calculateShipping = () => {
    const subtotal = calculateSubtotal();
    return subtotal >= 1000 ? 0 : 50;
  };

  // Calculate tax (18% GST)
  const calculateTax = () => {
    return calculateSubtotal() * 0.18;
  };

  // Calculate total
  const calculateTotal = () => {
    return calculateSubtotal() + calculateShipping() + calculateTax();
  };

  // Handle checkout
  const handleCheckout = () => {
    showSnackbar(
      `Order placed successfully! Total: ₹${calculateTotal().toFixed(2)}`,
    );
    // In real app, you would redirect to payment gateway
  };

  // Continue shopping
  const continueShopping = () => {
    window.location.href = "/";
  };

  const getDiscountedPrice = (mrp, discount) => {
    return mrp - (mrp * discount) / 100;
  };


 

  const isDeliverySelectionValid =
    deliveryOption === "door" ||
    (deliveryOption === "transport" && selectedTransport.trim().length > 0);

  const StateDropdown = ({ value, onChange, error }) => (
    <div className={`form-group ${error ? "has-error" : ""}`}>
      <label>
        State <span className="required-star">*</span>
      </label>
      <select
        name="state"
        value={value || ""}
        onChange={(e) => {
          const selectedName = e.target.value;
          onChange(e);
          const selectedState = states.find((s) => s.statename === selectedName);
          setStatecode(selectedState?.code || "");
        }}
        className={error ? "error" : ""}
        disabled={loadingStates}
      >
        <option value="">
          {loadingStates ? "Loading states..." : "Select State"}
        </option>
        {states.length > 0 ? (
          states.map((stateItem, index) => {
            const stateName =
              stateItem.statename || stateItem.state || stateItem.name;
            const stateValue = stateItem.code || stateItem.id || index;

            return (
              <option key={stateValue} value={stateName}>
                {stateName}
              </option>
            );
          })
        ) : (
          <option value="" disabled>
            {loadingStates ? "Loading..." : "No states available"}
          </option>
        )}
      </select>
      {error && <span className="error-message">{error}</span>}
    </div>
  );

  return (
    <div className="cart-page">
      <h2 className="cart-title">Your Shopping Cart</h2>

      <div className="cart-container">
        {cartItems.length === 0 ? (
          <div className="empty-cart">
            <FaShoppingCart className="empty-cart-icon" />
            <h3>Your cart is empty</h3>
            <p>Add some products to your cart to see them here.</p>
            <button
              className="continue-shopping-btn"
              onClick={continueShopping}
            >
              Continue Shopping
            </button>
          </div>
        ) : (
          <>
            <div className="cart-content">
              {isPaymentModalOpen && (
                <>
                  <Modal
                    open={isPaymentModalOpen}
                    footer={null}
                    closable={false}
                    centered
                    onCancel={() => isPaymentModalOpen(false)}
                    destroyOnHidden
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        marginTop: 50,
                      }}
                    >
                      <Spin size="large" />
                      <h2 style={{ textAlign: "center", marginTop: 50 }}>
                        Please Wait ...
                      </h2>
                    </div>
                  </Modal>
                </>
              )}
              {/* Cart Items List */}
              <div className="cart-items-section">
                <div className="cart-header">
                  <h3>Cart Items ({cartItems.length})</h3>
                  {/* <button className="clear-cart-btn" onClick={clearCart}>
                                        <FaTrash /> Clear Cart
                                    </button> */}
                </div>
                <div className="address-wrapper">
                  {address.map(
                    (item) =>
                      item.default === "1" &&
                      item.type === "BILL" && (
                        <>
                          <div className="address-card">
                            <div className="card-header">
                              <h3>Billing Address</h3>
                            </div>
                            <div className="card-body">
                              <p>
                                <strong>Name:</strong>
                                {item.name}
                              </p>
                             { item.firmname && ( <p>
                               
                                 <strong>Firm Name:</strong>
                                 {item.firmname}
                               
                              </p>)}
                              <p>
                                <strong>Address:</strong>
                                {item.flathouse},{item.area},{item.landmark}
                              </p>
                              <p>
                                <strong>City:</strong> {item.city}
                              </p>
                              <p>
                                <strong>State:</strong> {item.state}
                              </p>
                              <p>
                                <strong>Pincode:</strong>
                                {item.pincode}
                              </p>
                              <p>
                                <strong>Phone:</strong>
                                {item.phone}
                              </p>
                              {userType === "dealer" && item.gstno && (
                                <p>
                                  <strong>GST No.:</strong> {item.gstno}
                                </p>
                              )}
                              <p
                                style={{
                                  textAlign: "right",
                                  cursor: "pointer",
                                  color: "#1677ff",
                                }}
                                onClick={() =>
                                  navigate("/profile", {
                                    state: { openTab: "address" },
                                  })
                                }
                              >
                                <strong>Change</strong>
                              </p>
                            </div>
                          </div>
                        </>
                      ),
                  )}
                  {/* Shipping Address */}
                  {address.map(
                    (item) =>
                      item.default === "1" &&
                      item.type === "SHIP" && (
                        <>
                          <div className="address-card">
                            <div className="card-header">
                              <h3>Shipping Address </h3>
                            </div>
                            <div className="card-body">
                              <p>
                                <strong>Name:</strong>
                                {item?.name}
                              </p>
                            { item?.firmname && (
                              <p>
                                <strong>Firm Name:</strong>
                                {item?.firmname}
                              </p>
                            )}
                              <p>
                                <strong>Address:</strong>
                                {item?.flathouse},{item?.area},{item.landmark}
                              </p>
                              <p>
                                <strong>City:</strong> {item?.city}
                              </p>
                              <p>
                                <strong>State:</strong> {item?.state}
                              </p>
                              <p>
                                <strong>Pincode:</strong>
                                {item?.pincode}
                              </p>
                              <p>
                                <strong>Phone:</strong>
                                {item?.phone}
                              </p>
                              {userType === "dealer" && item.gstno && (
                                <p>
                                  <strong>GST No.:</strong> {item.gstno}
                                </p>
                              )}
                              <p
                                style={{
                                  textAlign: "right",
                                  cursor: "pointer",
                                  color: "#1677ff",
                                }}
                                onClick={() =>
                                  navigate("/profile", {
                                    state: { openTab: "address" },
                                  })
                                }
                              >
                                <strong>Change</strong>
                              </p>
                            </div>
                          </div>
                        </>
                      ),
                  )}

                  {/* Billing Address */}
                  

                </div>
                <div className="addAddress-btn" onClick={handleOpenAddAddressModal}>
                  + Add Address
                </div>

                {showAddressModal && (
                  <div className="modal-overlay" onClick={handleCloseAddressModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                      <div className="modal-header">
                        <h3>Add New Address</h3>
                        <button className="close-btn" onClick={handleCloseAddressModal}>
                          ×
                        </button>
                      </div>

                      <div className="modal-body">
                        <div className={`form-group ${formErrors.gstno ? "has-error" : ""}`}>
                          <label>GST Number</label>
                          <input
                            type="text"
                            name="gstno"
                            value={newAddress.gstno}
                            onChange={handleNewAddressChange}
                            onBlur={handleGstBlur}
                            placeholder="GST number (if applicable)"
                            className={formErrors.gstno ? "error" : ""}
                          />
                          {gstLoading && <span className="info-message">Fetching GST details...</span>}
                          {formErrors.gstno && <span className="error-message">{formErrors.gstno}</span>}
                        </div>
                        <div className={`form-group ${formErrors.name ? "has-error" : ""}`}>
                          <label>Full Name <span className="required-star">*</span></label>
                          <input
                            type="text"
                            name="name"
                            value={newAddress.name}
                            onChange={handleNewAddressChange}
                            placeholder="Enter full name"
                            className={formErrors.name ? "error" : ""}
                          />
                          {formErrors.name && <span className="error-message">{formErrors.name}</span>}
                        </div>

                        <div className={`form-group ${formErrors.firmname ? "has-error" : ""}`}>
                          <label>Firm Name</label>
                          <input
                            type="text"
                            name="firmname"
                            value={newAddress.firmname}
                            onChange={handleNewAddressChange}
                            placeholder="Enter firm name"
                            className={formErrors.firmname ? "error" : ""}
                          />
                          {formErrors.firmname && <span className="error-message">{formErrors.firmname}</span>}
                        </div>

                        <div className="form-row">
                          <div className={`form-group ${formErrors.phone ? "has-error" : ""}`}>
                            <label>Mobile Number <span className="required-star">*</span></label>
                            <input
                              type="tel"
                              name="phone"
                              value={newAddress.phone}
                              onChange={handleNewAddressChange}
                              placeholder="10-digit mobile number"
                              maxLength="10"
                              className={formErrors.phone ? "error" : ""}
                            />
                            {formErrors.phone && <span className="error-message">{formErrors.phone}</span>}
                          </div>

                          <div className={`form-group ${formErrors.altphone ? "has-error" : ""}`}>
                            <label>Alternate Number</label>
                            <input
                              type="tel"
                              name="altphone"
                              value={newAddress.altphone}
                              onChange={handleNewAddressChange}
                              placeholder="Alternate number"
                              maxLength="10"
                              className={formErrors.altphone ? "error" : ""}
                            />
                            {formErrors.altphone && <span className="error-message">{formErrors.altphone}</span>}
                          </div>
                        </div>

                        <div className={`form-group ${formErrors.email ? "has-error" : ""}`}>
                          <label>Email</label>
                          <input
                            type="email"
                            name="email"
                            value={newAddress.email}
                            onChange={handleNewAddressChange}
                            placeholder="Enter email"
                            className={formErrors.email ? "error" : ""}
                          />
                          {formErrors.email && <span className="error-message">{formErrors.email}</span>}
                        </div>

                        <div className={`form-group ${formErrors.flathouse ? "has-error" : ""}`}>
                          <label>Flat/House No. <span className="required-star">*</span></label>
                          <input
                            type="text"
                            name="flathouse"
                            value={newAddress.flathouse}
                            onChange={handleNewAddressChange}
                            placeholder="House number, building name"
                            className={formErrors.flathouse ? "error" : ""}
                          />
                          {formErrors.flathouse && <span className="error-message">{formErrors.flathouse}</span>}
                        </div>

                        <div className={`form-group ${formErrors.area ? "has-error" : ""}`}>
                          <label>Area/Street <span className="required-star">*</span></label>
                          <input
                            type="text"
                            name="area"
                            value={newAddress.area}
                            onChange={handleNewAddressChange}
                            placeholder="Area, street, sector, village"
                            className={formErrors.area ? "error" : ""}
                          />
                          {formErrors.area && <span className="error-message">{formErrors.area}</span>}
                        </div>

                        <div className={`form-group ${formErrors.landmark ? "has-error" : ""}`}>
                          <label>Landmark</label>
                          <input
                            type="text"
                            name="landmark"
                            value={newAddress.landmark}
                            onChange={handleNewAddressChange}
                            placeholder="Nearby landmark"
                            className={formErrors.landmark ? "error" : ""}
                          />
                          {formErrors.landmark && <span className="error-message">{formErrors.landmark}</span>}
                        </div>

                        <div className="form-row">
                          <div className={`form-group ${formErrors.city ? "has-error" : ""}`}>
                            <label>City <span className="required-star">*</span></label>
                            <input
                              type="text"
                              name="city"
                              value={newAddress.city}
                              onChange={handleNewAddressChange}
                              placeholder="City"
                              className={formErrors.city ? "error" : ""}
                            />
                            {formErrors.city && <span className="error-message">{formErrors.city}</span>}
                          </div>

                          <StateDropdown
                            value={newAddress.state}
                            onChange={handleNewAddressChange}
                            error={formErrors.state}
                          />
                        </div>

                        <div className="form-row">
                          <div className={`form-group ${formErrors.pincode ? "has-error" : ""}`}>
                            <label>Pincode <span className="required-star">*</span></label>
                            <input
                              type="text"
                              name="pincode"
                              value={newAddress.pincode}
                              onChange={handleNewAddressChange}
                              placeholder="6-digit pincode"
                              maxLength="6"
                              className={formErrors.pincode ? "error" : ""}
                            />
                            {formErrors.pincode && <span className="error-message">{formErrors.pincode}</span>}
                          </div>

                          <div className={`form-group ${formErrors.type ? "has-error" : ""}`}>
                  <label>Address Type <span className="required-star">*</span></label>
                  <select
                    name="type"
                    value={newAddress.type}
                    onChange={handleNewAddressChange}
                    className={formErrors.type ? "error" : ""}
                  >
                    <option value="">Select Address Type</option>
                    <option value="BILL">Billing</option>
                    <option value="SHIP">Shipping</option>
                  </select>
                  {formErrors.type && <span className="error-message">{formErrors.type}</span>}
                  <span style={{ display: "flex", gap: "6px", marginLeft: '9px' }}>
                    Use this for both
                    <span style={{ color: "black" }}>*</span>
                    <input
                      type="checkbox"
                      id="useSameAddressForBilling-add"
                      name="useSameAddressForBilling"
                      checked={newAddress.useSameAddressForBilling}
                      onChange={handleNewAddressChange}
                      style={{
                        width: 'auto',
                        margin: 0,
                      }}
                    />
                  </span>

                </div>
                        </div>

                        

                        {/* <div className="form-group">
                          <label
                            htmlFor="useSameAddressForBilling-checkout"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                              cursor: "pointer",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <span>Use this address for billing <span style={{ color: "black" }}>*</span></span>
                            <input
                              type="checkbox"
                              id="useSameAddressForBilling-checkout"
                              name="useSameAddressForBilling"
                              checked={newAddress.useSameAddressForBilling}
                              onChange={handleNewAddressChange}
                              style={{ margin: 0 }}
                            />
                          </label>
                        </div> */}

                        <div className="form-group">
                          <label>Country</label>
                          <input
                            type="text"
                            name="country"
                            value={newAddress.country}
                            onChange={handleNewAddressChange}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="modal-actions">
                        <button className="btn-secondary" onClick={handleCloseAddressModal} disabled={addingAddress}>
                          Cancel
                        </button>
                        <button className="btn-primary" onClick={handleAddAddress} disabled={addingAddress}>
                          {addingAddress ? "Adding..." : "Add Address"}
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <div className="cart-items-list">
                  {cartItems.map((item) => (<>
                    <div className="cart-item" key={item.dtl[0]?.productid}>
                      <div className="item-image">
                        <img
                          src={withImageVersion(item.dtl[0]?.image1?.trim()) || noimage}
                          alt={item.name}
                          onError={(e) => (e.target.src = noimage)}
                          onClick={() =>
                            navigate(
                              `/productdetail?productid=${item.dtl[0]?.productid}`,
                            )
                          }
                        />
                      </div>

                      <div className="item-details">
                        <h5 >
                          {(item.dtl[0]?.displaymodelno).toUpperCase()}
                        </h5>
                        <h6 >
                          {item.dtl[0]?.subcategory}
                        </h6>
                        <p className="item-category">{item.dtl[0]?.category}</p>

                        <div className="price-container" style={{ marginTop: 10 }}>
                          {Number(item.dtl?.[0]?.netrate) > 0 ? (
                            <span className="current-price">₹{Number(item.dtl?.[0]?.netrate || 0).toFixed(2)}</span>
                          ) : (
                            <>
                              <span className="current-price">
                                ₹{(Number(item.gross) / item.qty).toFixed(2)}
                              </span>

                              <span className="mrp-price" style={{ textDecoration: "line-through", color: "#828282", marginLeft: 10 }}>
                                ₹{(Number(item.mrp) / item.qty).toFixed(2)}
                              </span>


                              {(Number(item.dtl?.[0]?.discount) > 0 ||
                                Number(item.spldis) > 0 ||
                                Number(item.dealerdis) > 0) && (
                                  <>
                                    {(Number(item.dtl?.[0]?.discount) > 0 ||
                                      Number(item.spldis) > 0) && (
                                        <span className="discount-price">
                                          {Number(item.dtl?.[0]?.discount || 0)}%
                                          {Number(item.spldis) > 0 && ` + ${Number(item.spldis)}%`}
                                          {" OFF"}
                                        </span>
                                      )}

                                    {Number(item.dealerdis) > 0 && (
                                      <span className="discount-price">
                                        {Number(item.dealerdis)}% OFF
                                      </span>
                                    )}
                                  </>
                                )}


                            </>
                          )}
                        </div>
                        {item.dtl[0]?.stock < item.qty && (
                          <h6 style={{ color: "red" }}> Out Of Stock</h6>
                        )}

                        <div style={{ display: 'flex' }}> <button style={{ marginRight: 10 }}
                          className="remove-item-btn"
                          onClick={() =>
                            handleDelete(userId, item.dtl[0]?.productid)
                          }
                        >
                          <FaTrash style={{ marginRight: "6px" }} />
                          Delete
                        </button>
                          <div className="item-quantity">
                            {(() => {
                              const qtyStep = getQuantityStep(item.dtl[0]);
                              return (
                                <>
                                  <button
                                    className="quantity-btn"
                                    onClick={() =>
                                      handlePress(
                                        userId,
                                        item.dtl[0]?.productid,
                                        Number(item.qty) - qtyStep,
                                        item.dtl[0]?.stock,
                                        qtyStep,
                                        "minus",
                                      )
                                    }
                                  >
                                    <FaMinus />
                                  </button>
                                  <span className="quantity-value">{item.qty}</span>
                                  <button
                                    className="quantity-btn"
                                    onClick={() =>
                                      handlePress(
                                        userId,
                                        item.dtl[0]?.productid,
                                        Number(item.qty) + qtyStep,
                                        item.dtl[0]?.stock,
                                        qtyStep,
                                        "add",
                                      )
                                    }
                                  >
                                    <FaPlus />
                                  </button>
                                </>
                              );
                            })()}
                          </div></div>
                      </div>
                      <div style={{ textAlign: 'left', minWidth: 200 }}>
                        <p style={{ padding: 0, margin: 0 }}>MRP : ₹{(Number(item?.mrp || 0)).toFixed(2)}</p>
                        <p style={{ padding: 0, margin: 0 }}>Net Rate : ₹{(item.dtl[0]?.netrate ? Number(item.dtl[0]?.netrate * item.qty) : Number(item?.mrp || 0)).toFixed(2)}</p>
                        <p style={{ padding: 0, margin: 0 }}>Discount({Number(item.dtl?.[0]?.discount || item.dis || 0)}%) : ₹{((item?.disamount ?? item?.disa ?? 0)).toFixed(2)}</p>
                        {item?.dealerdisamt != null && Number(item.dealerdisamt) > 0 && (
                          <p style={{ padding: 0, margin: 0 }}>
                            Dealer Discount ({item.dealerdis}%): ₹{((item.dealerdisamt)).toFixed(2)}
                          </p>
                        )}
                        {Number(item.splamount) != 0 && <p style={{ padding: 0, margin: 0 }}>Special Discount({item.spldis}%) : {((item.splamount ?? 0)).toFixed(2)}</p>}
                        {/* <p style={{padding:0,margin:0}}>After Discount : {item.afterdis}</p>  */}
                        <p style={{ padding: 0, margin: 0 }}>GST ({item.gstp ?? item["gst%"]}%) : ₹{((item.gsta ?? 0)).toFixed(2)}</p>
                        {Number(item.dtl?.[0]?.netrate) > 0 ?
                          <h6>Total : ₹{Number(item.dtl?.[0]?.netrate * item.qty || 0).toFixed(2)}</h6>
                          : <h6>Total : ₹{((item?.gross)).toFixed(2)}</h6>}
                      </div>
                    </div>
                    {item?.dtl[0]?.free_items[0]?.minqty <= item.qty && (
                      <>
                        <h5>Free Items</h5>
                        {item?.dtl[0]?.free_items?.map((items, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: 'space-around',
                              border: "1px solid #e0e0e0",
                              borderRadius: 12,
                              padding: 20,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                              background: "#fff",
                            }}
                          >
                            <img
                              onClick={() => navigate(`/productdetail?productid=${items.feeproductid}`)}
                              src={withImageVersion(items.image)}
                              alt={items.product_name}
                              style={{
                                width: 120,
                                objectFit: "contain",
                                borderRadius: 10,
                              }}
                            />
                            <div>
                              <h6 style={{ margin: "0 0 6px 0" }}>
                                {items.product_name}
                              </h6>

                              <p style={{ margin: "0 0 6px 0", color: "#666", fontSize: 14 }}>
                                {items.category}
                              </p>
                              <p style={{ margin: "0 0 6px 0", color: "#666", fontSize: 14 }}>
                                Qty : {items.qty}
                              </p>

                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                                <p
                                  style={{
                                    margin: 0,
                                    textDecoration: "line-through",
                                    color: "#999",
                                    fontSize: 14,
                                  }}
                                >
                                  MRP: ₹{Number(items.price || 0).toFixed(2)}
                                </p>

                                <span
                                  style={{
                                    alignSelf: "flex-start",
                                    padding: "4px 10px",
                                    background: "#e6f4ff",
                                    color: "#005487",
                                    borderRadius: 20,
                                    fontSize: 12,
                                    fontWeight: 600,
                                  }}
                                >
                                  FREE
                                </span></div></div>
                          </div>
                        ))}</>)}
                  </>
                  ))}
                </div>

                <div className="continue-shopping">
                  <button
                    className="continue-shopping-btn"
                    onClick={continueShopping}
                  >
                    ← Continue Shopping
                  </button>
                </div>
              </div>

              {/* Order Summary */}
              <div className="order-summary">
                <h3>Order Summary</h3>

                <div className="summary-details">
                  <div className="summary-row">
                    <span>MRP Total</span>
                    <span>₹{totals.totalMRP.toFixed(2)}</span>
                  </div>

                  <div className="summary-row">
                    <span>Total Discount</span>
                    <span className="summary-row">
                      ₹{(totals.totalMRP - totals.totalGross - totals.totalDlrDisc).toFixed(2)}
                    </span>
                  </div>
                  {totals.totalDlrDisc != 0 && (
                    <div className="summary-row">
                      <span>Dealer Discount</span>
                      <span
                        className={"summary-row"}
                      >
                        ₹{(totals.totalDlrDisc).toFixed(2)}
                      </span>
                    </div>
                  )}


                  <div className="summary-row">
                    <span>Total Amount(After Discount)</span>
                    <span className="summary-row">
                      ₹
                      {(
                        totals.totalMRP -
                        (totals.totalMRP - totals.totalGross)
                      ).toFixed(2)}
                    </span>
                  </div>
                   <div className="summary-row">
                    <span>Taxable Amount</span>
                    <span className="summary-row">
                      ₹
                      {(
                        (totals.totalMRP -
                        (totals.totalMRP - totals.totalGross)
                      )-totals.totalGst).toFixed(2)}
                    </span>
                  </div>
                   <div className="summary-row">
                    <span>Tax (GST)</span>
                    <span>₹{totals.totalGst.toFixed(2)}</span>
                  </div>


                  {deliveryOption === "door" && d_pin != 0 && (
                    <div className="summary-row">
                      <span>Shipping Charges</span>
                      <span
                        className={"summary-row"}
                        style={{
                          textDecoration:
                            deliveryOption === "door" && totals.totalGross >= shippingSetting
                              ? "line-through"
                              : "",
                        }}
                      >
                        ₹{shippingCost.toFixed(2)}
                      </span>
                    </div>
                  )}
                  {couponAmount != 0 && (
                    <div className="summary-row">
                      <span>Coupon Discount</span>
                      <span className={"summary-row"}>
                        - ₹{couponAmount.toFixed(2)}
                      </span>
                    </div>
                  )}

                  {useWallet && (
                    <div className="summary-row">
                      <span>Wallet</span>
                      <span className={"summary-row"}> - ₹{Number(walletAmount || 0).toFixed(2)}</span>
                    </div>
                  )}

                 
                  {/* <div className="summary-row">
                    <span>Total(including GST)</span>₹
                    {totals.totalGross.toFixed(2)}
                  </div> */}

                  <div className="summary-divider"></div>

                  <div className="summary-row total">
                    <span>Total </span>
                    <span className="total-amount">
                      ₹{Number(totalPayable).toFixed(2)}
                    </span>
                  </div>

                  <div
                    role="radiogroup"
                    aria-label="Delivery option"
                    style={{ margin: "16px 0", display: "grid", gap: 8 }}

                  >
                    <h5 style={{ margin: "0 0 4px", color: "#005487", fontWeight: "bold" }}>Select Delivery Method *</h5>
                    {isHeavyWeight && (
                      <small style={{ color: "#d32f2f", fontSize: 13 }}>
                        Door Delivery not available for above 30 kgs.
                      </small>
                    )}

                    <label style={{ cursor: isHeavyWeight ? "not-allowed" : "pointer", display: "flex", alignItems: "center", gap: 8 }}>
                      <input
                        type="radio"
                        name="deliveryOption"
                        value="door"
                        checked={deliveryOption === "door"}
                        onChange={() => setDeliveryOption("door")}
                        disabled={isHeavyWeight}
                      />
                      Door Delivery
                    </label>
                    <label style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}>
                      <input
                        type="radio"
                        name="deliveryOption"
                        value="transport"
                        checked={deliveryOption === "transport"}
                        onChange={() => {
                          setDeliveryOption("transport");
                        }}
                      />
                      Transport Delivery
                    </label>
                    {deliveryOption === "transport" && (
                      <div style={{ display: "grid", gap: 6, paddingLeft: 24 }}>
                        <label htmlFor="transport-office" style={{ color: "#666", fontSize: 14 }}>
                          Transport Name
                        </label>
                        <input
                          type="text"
                          id="transport-office"
                          value={selectedTransport}
                          onChange={(event) => setSelectedTransport(event.target.value)}
                          placeholder="Enter transport Name"
                          required
                          aria-required="true"
                          style={{ maxWidth: 260, padding: "8px", borderRadius: 6, border: "1px solid #ccc" }}
                        />
                        {!selectedTransport.trim() && (
                          <small style={{ color: "#d32f2f" }}>Transport Name is required.</small>
                        )}
                        <small style={{ color: "#666" }}>
                          Shipping charges must be paid at the transport office at the time of item collection.
                        </small>
                      </div>
                    )}
                  </div>


                  {/* <div className="shipping-note">
                    {deliveryOption === "transport" ? (
                      <p>Pay shipping charges at the transport office while collecting your items.</p>
                    ) : deliveryOption === "door" && totals.totalGross < shippingSetting ? (
                      <p>
                        Add ₹{(shippingSetting - totals.totalGross).toFixed(2)} more to
                        get FREE shipping!
                      </p>
                    ) : deliveryOption === "door" ? (
                      <p className="free-shipping">
                        {totals.totalGross >= shippingSetting
                          ? " You qualify for FREE shipping!"
                          : `Shop more ₹${shippingSetting - totals.totalGross} to get FREE shipping`}
                      </p>
                    ) : null}
                  </div> */}
                </div>



                {/* <div
                  role="radiogroup"
                  aria-label="Payment method"
                  style={{ margin: "16px 0", display: "grid", gap: 8 }}
                >
                  <h5 style={{ margin: "0 0 4px", color: "#005487", fontWeight: "bold" }}>Select Payment Method *</h5>
                  <label style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}>
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="razorpay"
                      checked={paymentMethod === "razorpay"}
                      onChange={() => setPaymentMethod("razorpay")}
                    />
                    Pay Online (Razorpay)
                  </label>
                  <label style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}>
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="bank"
                      checked={paymentMethod === "bank"}
                      onChange={() => setPaymentMethod("bank")}
                    />
                    Bank Transfer 
                  </label>
                  {paymentMethod === "bank" && (
                    <div style={{ display: "grid", gap: 6, paddingLeft: 24 }}>
                      <small style={{ color: "#666" }}>
                        Transfer manually and submit your UTR number
                      </small>
                      <small style={{ color: "#666" }}>
                        Packing will be done after successful verification of payment.
                      </small>
                    </div>
                  )}
                </div> */}

                <button
                  className="checkout-btn"
                  disabled={!isDeliverySelectionValid }
                  onClick={() => {
                    if (!address || address.length === 0) {
                      handleOpenAddAddressModal();
                      return;
                    }
                    if (paymentMethod === "razorpay") {
                      if (deliveryOption === "transport") {
                        setShowTransportModal(true);
                      } else {
                        setUtrNumber("");
                        setUtrError("");
                        checkStockBeforePayment(Number(totalPayable).toFixed(2), "INR", 1);
                      }
                    } else if (paymentMethod === "bank") {
                      setUtrNumber("");
                      setUtrError("");
                      setShowPaymentMethodModal(true);
                    }
                  }}
                >
                  PAY NOW
                </button>
                {walletAmount != "0.00" && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', paddingRight: 20, borderWidth: 1 }}>
                    <h5 style={{ color: "#005487" }}>Use Wallet Amount</h5>
                    <Switch onChange={onChange} disabled={totals.totalGross < walletSetting} />
                  </div>)}

                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <input
                      name="Enter coupon code"
                      value={coupon}
                      onChange={(e) => setCoupon(e.target.value)}
                      placeholder="Enter Coupon"
                      style={{
                        height: 50,
                        padding: "8px",
                        borderRadius: "10px",
                        border: "1px solid #ccc",
                        fontSize: "18px",
                      }}
                    />
                    <button
                      className="checkout-btn"
                      onClick={() => handleApplyCoupon()}
                      disabled={isapplying}
                    >
                      Apply
                    </button>
                  </div>
                  {couponAmount > 0 && (
                    <small style={{ color: "#28a745", fontWeight: 600, paddingLeft: 4 }}>
                      Coupon applied &mdash; ₹{couponAmount.toFixed(2)} off
                    </small>
                  )}
                </div>
                <Modal
                  title={deliveryOption === "transport" ? "Transport Terms & Bank Transfer" : "Bank Transfer / NEFT / RTGS"}
                  open={showPaymentMethodModal}
                  onCancel={() => setShowPaymentMethodModal(false)}
                  footer={null}
                  centered
                  width={520}
                >
                  <div style={{ padding: "8px 0" }}>
                    {deliveryOption === "transport" && (
                      <>
                        <div
                          style={{
                            marginBottom: 16,
                            padding: "10px 12px",
                            borderRadius: 8,
                            background: "#f5f9ff",
                          }}
                        >
                          <span
                            onClick={() => setShowTransportModal(true)}
                            style={{
                              color: "#005487",
                              fontWeight: 600,
                              fontSize: 14,
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                          >
                            Transport Terms &amp; Conditions
                          </span>
                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              marginTop: 10,
                              cursor: "pointer",
                              fontWeight: 500,
                              fontSize: 14,
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={acceptTransportTerms}
                              onChange={(e) =>
                                setAcceptTransportTerms(e.target.checked)
                              }
                            />
                            I have read and accept the Transport Terms &amp; Conditions.
                          </label>
                          {!acceptTransportTerms && (
                            <small style={{ color: "#d32f2f" }}>
                              Please accept the terms and conditions to continue.
                            </small>
                          )}
                        </div>
                        <hr style={{ border: "none", borderTop: "1px solid #e0e0e0", margin: "0 0 12px" }} />
                      </>
                    )}

                    <div style={{ fontWeight: 600, fontSize: 15, color: "#005487", marginBottom: 8 }}>Bank Transfer Details</div>
                    <div style={{ background: "#f5f9ff", borderRadius: 8, padding: 12, marginBottom: 12 }}>
                      <p style={{ margin: "2px 0" }}><strong>Account Name:</strong> {BANK_DETAILS.accountName}</p>
                      <p style={{ margin: "2px 0" }}><strong>Account Number:</strong> {BANK_DETAILS.accountNumber}</p>
                      <p style={{ margin: "2px 0" }}><strong>IFSC:</strong> {BANK_DETAILS.ifsc}</p>
                      <p style={{ margin: "2px 0" }}><strong>Bank:</strong> {BANK_DETAILS.bankName}</p>
                      <p style={{ margin: "2px 0" }}><strong>Branch:</strong> {BANK_DETAILS.branch}</p>
                      <p style={{ margin: "8px 0 0" }}>
                        <strong>Amount to transfer:</strong> ₹{(Number(totalPayable)).toFixed(2)}
                      </p>
                    </div>

                    <div className={`form-group ${utrError ? "has-error" : ""}`}>
                      <label>UTR / Transaction Reference Number <span className="required-star">*</span></label>
                      <input
                        type="text"
                        value={utrNumber}
                        onChange={(e) => {
                          setUtrNumber(e.target.value);
                          if (utrError) setUtrError("");
                        }}
                        placeholder="Enter UTR number after completing transfer"
                        className={utrError ? "error" : ""}
                      />
                      {utrError && <span className="error-message">{utrError}</span>}
                    </div>

                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 12 }}>
                      <button
                        className="btn-secondary"
                        onClick={() => setShowPaymentMethodModal(false)}
                        disabled={submittingBankTransfer}
                      >
                        Cancel
                      </button>
                      <button
                        className="checkout-btn"
                        onClick={handleBankTransferSubmit}
                        disabled={submittingBankTransfer || (deliveryOption === "transport" && !acceptTransportTerms)}
                      >
                        {submittingBankTransfer ? "Submitting..." : "Submit Payment"}
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal
                  title="Transport Terms & Conditions"
                  open={showTransportModal}
                  onCancel={() => {
                    setShowTransportModal(false);
                    setAcceptTransportTerms(false);
                  }}
                  footer={null}
                  centered
                >
                  <div style={{ padding: "8px 0" }}>
                    <div
                      style={{
                        display: "grid",
                        gap: 12,
                        fontSize: 14,
                        color: "#333",
                        lineHeight: 1.5,
                      }}
                    >
                      <div>
                        <strong>Transport Charges:</strong> The customer is
                        responsible for paying the applicable transport charges.
                      </div>
                      <div>
                        <strong>Transport Availability:</strong> Transport
                        service should be available at our location. If the
                        requested transport service is not available, we will
                        either arrange an alternative transport service or
                        cancel the order.
                      </div>
                      <div>
                        <strong>Transport Damage:</strong>
                         If the damage occurred during transportation,
                          the transporter shall be responsible for the loss/damage, 
                          subject to the transporter's terms and applicable law.
                      </div>
                      <div>
                        <strong>Order Return:</strong> In case of an order
                        return, both forward and return transport charges will
                        be applicable and will be charged to the customer's
                        account.
                      </div>
                    </div>

                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        margin: "16px 0 4px",
                        cursor: "pointer",
                        fontWeight: 500,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={acceptTransportTerms}
                        onChange={(e) =>
                          setAcceptTransportTerms(e.target.checked)
                        }
                      />
                      I have read and accept the above Terms &amp; Conditions.
                    </label>
                    {!acceptTransportTerms && (
                      <small style={{ color: "#d32f2f" }}>
                        Please accept the terms and conditions to continue.
                      </small>
                    )}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 10,
                        marginTop: 12,
                      }}
                    >
                      <button
                        className="btn-secondary"
                        onClick={() => {
                          setShowTransportModal(false);
                          setAcceptTransportTerms(false);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        className="checkout-btn"
                        disabled={!acceptTransportTerms}
                        onClick={() => {
                          setAcceptTransportTerms(true);
                          setShowTransportModal(false);
                          if (paymentMethod === "bank") {
                            setUtrNumber("");
                            setUtrError("");
                            setShowPaymentMethodModal(true);
                          } else {
                            setUtrNumber("");
                            setUtrError("");
                            checkStockBeforePayment(Number(totalPayable).toFixed(2), "INR", 1);
                          }
                        }}
                      >
                        Accept &amp; Continue
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal
                  title="Coupons"
                  open={isModalOpen}
                  onOk={handleOk}
                  onCancel={handleCancel}
                >
                  {
                    (coupons.filter((c) => c.active != 0).length > 0) ? (
                      coupons
                        .filter((c) => c.active != 0)
                        .map((item) => (
                          <div
                            key={item.couponid}
                            onClick={() => {
                              setCoupon(item.couponid);
                              setCouponid(item.cid);
                              setIsModalOpen(false);
                            }}
                            style={{
                              backgroundColor: "#E6F2FF",
                              padding: 10,
                              marginVertical: 8,
                              marginHorizontal: 16,
                              borderRadius: 10,
                              marginBottom: 10,
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ width: "70%" }}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: 10,
                                  marginBottom: 10,
                                }}
                              >
                                <h2 style={{ fontSize: 14, color: "#005487" }}>
                                  {item.couponid}
                                </h2>
                              </div>
                              <h4 style={{ fontSize: 12, marginBottom: 4 }}>
                                {item.coupondesc}
                              </h4>
                              {item.disc1 && (
                                <h4 style={{ fontSize: 12, marginBottom: 4 }}>
                                  ● {item.disc1}
                                </h4>
                              )}
                              {item.disc2 && (
                                <h4 style={{ fontSize: 12, marginBottom: 4 }}>
                                  ● {item.disc2}
                                </h4>
                              )}
                              {item.disc3 && (
                                <h4 style={{ fontSize: 12, marginBottom: 4 }}>
                                  ● {item.disc3}
                                </h4>
                              )}
                              {item.disc4 && (
                                <h4 style={{ fontSize: 12, marginBottom: 4 }}>
                                  ● {item.disc4}
                                </h4>
                              )}
                              <h4 style={{ fontSize: 12 }}>
                                Start Date: {item.validfrom}
                              </h4>
                              <h4 style={{ fontSize: 12 }}>
                                Expiry Date: {item.validto}
                              </h4>
                            </div>
                            <div />
                          </div>
                        ))
                    ) : (
                      <p style={{ padding: 12 }}>No active coupons available.</p>
                    )
                  }
                </Modal>
                <h4
                  style={{ color: "#005487", cursor: "pointer" }}
                  onClick={showModal}
                >
                  View Coupons
                </h4>
                <div className="security-note">
                  <p><FaLock color="#005487" /> Your payment information is secure and encrypted.</p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Checkout;
